import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import PropTypes from "prop-types";
import { equals, pick } from "ramda";
import { Flex } from "@base-ui";
import Icon from "@cms/components/ui/Icon";
import Quote from "@cms/components/ui/Quote";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["layout", "flexbox", "space"];
var IconQuote = function IconQuote(props) {
  var iconQuote = props.iconQuote,
    inverted = props.inverted;
  return /*#__PURE__*/_jsxs(Flex.Column, _objectSpread(_objectSpread({
    height: "100%",
    minHeight: "250px",
    backgroundColor: inverted ? "P3" : ""
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(Icon, {
      icon: "".concat(iconQuote.src, "_lg"),
      inverted: inverted,
      p: "30px 20px 10px",
      m: "auto auto 0",
      height: "fit-content"
    }), /*#__PURE__*/_jsx(Quote, {
      quote: iconQuote,
      inverted: inverted,
      m: "0 auto auto",
      p: "5px 20px 10px",
      height: "fit-content"
    })]
  }));
};
IconQuote.propTypes = {
  iconQuote: PropTypes.object.isRequired,
  style: PropTypes.object
};
export default /*#__PURE__*/memo(IconQuote, function (prev, curr) {
  return equals(pick(["iconQuote"], prev), pick(["iconQuote"], curr));
});